<template>
    <!-- <div>  	   -->
    <b-form-group
        :class="{
            'required-field': true,
        }"
        label-for="inputId"
    >
        <label v-if="isUrdu" for="" class="urdu-label"
            >شناختی دستاویز کی بیک اسکین کاپی</label
        >
        <label v-else class="">ID DOCUMENT BACK SCAN COPY</label>
        <!-- <label for=""
            >ID DOCUMENT FRONT SCAN COPY
            <span
                 v-if="ssaAccount"
                class="urdu-label"
            >
                (شناختی دستاویز کی فرنٹ اسکین کاپی)
                </span></label> -->
        <b-form-file
            ref="file-input"
            v-model="model"
            v-validate="{
                required: !!identityInfoType,
            }"
            class="col-md-10"
            input-id="identity"
            :placeholder="
                originalFileName ||
                'Select scan copy (JPG, PNG, PDF or TIFF file)'
            "
            drop-placeholder="Drop file here..."
            file-type="identityNew"
            accept="image/*, application/pdf"
            :disabled="!identityInfoType"
            data-vv-name="ID document back scan copy"
            :class="{
                'is-invalid': errors.has('document scan copy'),
                'required-field': !!identityInfoType,
            }"
            @input="uploadImage"
        ></b-form-file>
        <b-modal
            ref="modal"
            size="lg"
            title="Identity Document"
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            @close="onHidden"
        >
            <cropper
                v-if="this.fileType !== 'application/pdf'"
                ref="cropper"
                :src="image"
                class="upload-example-cropper"
            ></cropper>
            <!-- <button v-on:click="rotateImage">Rotate Image</button> -->
            <template #modal-footer="{}">
                <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="rotateImage"
                >
                    Rotate
                </b-button>
                <b-button size="sm" variant="danger" @click="onHidden">
                    Cancel
                </b-button>
                <b-button size="sm" variant="success" @click="crop">
                    OK
                </b-button>
            </template>
        </b-modal>
    </b-form-group>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import TextField from './TextField'
import request from '@/utils/request'

export default {
    // End of Component > watch

    components: {
        Cropper,
    },
    extends: TextField, // End of Component > inject

    props: {
        field: {
            type: Object,
            default() {
                return {
                    isRequired: true,
                    isLocked: true,
                    key: 'documentInfo.cnicBack.fileName',
                    originalFileNameKey:
                        'documentInfo.cnicBack.originalFileName',
                }
            },
            required: false,
        },
        dataSegmentId: {
            type: String,
            required: false,
        },
    }, // End of Component > props
    data() {
        return {
            image: '',
            selectedFileName: '',
            fileType: '',
        }
    }, // End of Component > Data
    computed: {
        identityInfoType() {
            return this.$store.getters.getField('identityInfo.type')
        },
        originalFileName() {
            return this.$store.getters.getField(this.field.originalFileNameKey)
        },
        ssaAccount() {
            if (this.dataSegmentId == process.env.VUE_APP_SSA_ACCOUNT)
                return true
        },
        isUrdu() {
            let lang = this.$store.getters.getField('languageOption')
            if (lang == 'urd') {
                return true
            }
        },
    },
    watch: {},
    inject: {
        $validator: '$validator',
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {},
    methods: {
        onHidden() {
            this.$refs['file-input'].reset()

            this.$refs.modal.hide()
            this.$store.commit('updateField', {
                key: this.field.key,
                value: null,
            })
            this.updateOriginalFileName(null)
            this.$store.commit(
                'setError',
                'Please upload ID Document Back Scan Copy'
            )
            // console.log('modal-hide-finsih')
        },
        onHidden2() {
            this.$refs['file-input'].reset()

            this.$refs.modal.hide()
            this.$store.commit('updateField', {
                key: this.field.key,
                value: null,
            })
            this.updateOriginalFileName(null)

            // console.log('modal-hide-finsih')
        },
        rotateImage() {
            var image = document.createElement('img')
            image.crossOrigin = 'anonymous'
            image.src = this.image
            image.onload = () => {
                var canvas = document.createElement('canvas')
                var ctx = canvas.getContext('2d')

                /**
                 * Rotating Image 90 degrees
                 */
                if (image.width > image.height) {
                    canvas.width = image.height
                    canvas.height = image.width
                    ctx.translate(image.height, image.width / image.height)
                } else {
                    canvas.height = image.width
                    canvas.width = image.height
                    ctx.translate(image.height, image.width / image.height)
                }
                ctx.rotate(Math.PI / 2)
                ctx.drawImage(image, 0, 0)

                // /**
                //  * Rotating Image 180 Degrees */
                // canvas.width = image.width;
                // canvas.height = image.height;
                // ctx.translate(canvas.width / 2,canvas.height / 2);
                // // Rotate the image and draw it on the canvas.
                // 	// (I am not showing the canvas on the webpage.
                // ctx.rotate(Math.PI);
                // ctx.drawImage(image, -image.width / 2, -image.height / 2);

                this.image = canvas.toDataURL()
            }
        },
        updateOriginalFileName(newValue) {
            // console.log('New Values: ' + newValue)
            // console.log('New Values: ' + this.field.originalFileNameKey)
            this.$store.commit('updateField', {
                key: this.field.originalFileNameKey,
                value: newValue,
            })
        },
        change({ coordinates, canvas }) {
            // console.log(coordinates, canvas)
        },
        crop() {
            // console.log(this.$refs)
            // const { coordinates, canvas, } = this.$refs.cropper.getResult();
            const result = this.$refs.cropper.getResult()
            // console.log(result)
            // this.coordinates = coordinates;
            // You able to do different manipulations at a canvas
            // but there we just get a cropped image, that can be used
            // as src for <img/> to preview result
            this.image = result.canvas.toDataURL()
            // Split the base64 string in data and contentType
            var block = this.image.split(';')
            // Get the content type of the image
            var contentType = block[0].split(':')[1] // In this case "image/gif"
            // get the real base64 content of the file
            var realData = block[1].split(',')[1] // In this case "R0lGODlhPQBEAPeoAJosM...."
            // Convert it to a blob to upload
            var blob = this.b64toBlob(realData, contentType)

            var file = new File([blob], this.selectedFileName)
            // console.log(file)
            // this.onFileInput(file)
            this.encrypt(file)
            this.$refs.modal.hide()
        },
        uploadImage(file) {
            // console.log('file: ', file )
            // Reference to the DOM input element
            // var input = event.target;
            // // Ensure that you have a file before attempting to read it
            if (file) {
                // console.log("file.type", file.type)
                if (
                    file.type === 'image/jpeg' ||
                    file.type === 'image/jpg' ||
                    file.type === 'image/png'
                ) {
                    if (this.skipCrop()) {
                        this.updateOriginalFileName(file.name)
                        this.selectedFileName = file.name
                        this.fileType = file.type
                        this.image = null
                        this.encrypt(file)
                        return
                    }
                    // console.log('UploadImage: ' + file)
                    this.updateOriginalFileName(file.name)
                    this.selectedFileName = file.name
                    this.fileType = file.type
                    // console.log(
                    //     'selectedFileName: ' + this.selectedFileName,
                    //     this.fileType
                    // )
                    // create a new FileReader to read this image and convert to base64 format
                    var reader = new FileReader()
                    // Define a callback function to run, when FileReader finishes its job
                    reader.onload = (e) => {
                        // console.log(e)
                        // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                        // Read image as base64 and set to imageData
                        this.image = e.target.result
                    }
                    // Start the reader job - read file as a data url (base64 format)
                    reader.readAsDataURL(file)
                    this.$refs.modal.show()
                } else if (file.type === 'application/pdf') {
                    this.updateOriginalFileName(file.name)
                    this.selectedFileName = file.name
                    this.fileType = file.type
                    this.image = null
                    this.encrypt(file)
                } else {
                    // console.log("file.type", file.type)
                    this.$store.commit('setError', 'File format not supported')
                    this.onHidden2()
                }
            } else {
                // this.$store.commit(
                //     'setError',
                //     'Please upload ID Document Front Scan Copy'
                // )
                this.onHidden2()
            }
        },
        async onFileInput(file) {
            // console.log('File: ' + file)
            if (file) {
                this.$store.commit('setLoading', true)
                try {
                    const formData = new FormData()

                    formData.append('type', 'cnicBack')
                    formData.append('file', file, file.name)

                    const headers = {
                        'Content-Type': 'multipart/form-data',
                    }
                    const { data } = await request.post(
                        'files/encrypt',
                        formData,
                        {
                            headers,
                        }
                    )

                    // console.log('FileName: ' + data.data.fileName)
                    // console.log('FileName: ' + file.name)

                    this.$store.commit('updateField', {
                        key: this.field.key,
                        value: data.data.fileName,
                    })

                    this.$emit('input', data.data.fileName)
                    this.updateOriginalFileName(file.name)
                } catch (error) {
                    // console.log(error)
                }
                this.$store.commit('setLoading', false)
            }
        },
        encrypt(input) {
            // console.log(input)
            var file = input
            var reader = new FileReader()
            reader.onload = () => {
                var key = process.env.VUE_APP_CSK
                var wordArray = this.CryptoJS.lib.WordArray.create(
                    reader.result
                ) // Convert: ArrayBuffer -> WordArray
                var encrypted = this.CryptoJS.AES.encrypt(
                    wordArray,
                    key
                ).toString() // Encryption: I: WordArray -> O: -> Base64 encoded string (OpenSSL-format)

                var fileEnc = new Blob([encrypted]) // Create blob from string
                var filename = file.name + '.enc'
                const myFile = new File([fileEnc], filename, {
                    type: fileEnc.type,
                })

                this.onFileInput(myFile)
            }
            reader.readAsArrayBuffer(file)
            // console.log(file)
        },
        b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || ''
            sliceSize = sliceSize || 512

            var byteCharacters = atob(b64Data)
            var byteArrays = []

            for (
                var offset = 0;
                offset < byteCharacters.length;
                offset += sliceSize
            ) {
                var slice = byteCharacters.slice(offset, offset + sliceSize)

                var byteNumbers = new Array(slice.length)
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i)
                }

                var byteArray = new Uint8Array(byteNumbers)

                byteArrays.push(byteArray)
            }

            var blob = new Blob(byteArrays, { type: contentType })
            return blob
        },
        skipCrop() {
            const envSkip = process.env.VUE_APP_SKIP_IDENTITY_DOCUMENT_CROP
            if (envSkip === true || envSkip === 'true') {
                return true
            }
            const segmentId =
                this.dataSegmentId ||
                this.$store.getters.dataSegmentId ||
                (this.$route.params && this.$route.params.dataSegmentId)
            const ssaId = process.env.VUE_APP_SSA_ACCOUNT
            if (segmentId && ssaId && String(segmentId) === String(ssaId)) {
                return true
            }
            return false
        },
    }, // End of Component > mounted
}
</script>

<style>
.upload-example-cropper {
    border: solid 1px #eee;
    min-height: 150px;
    width: 100%;
}
</style>
